export function cityBounds(i) {
  var bounds = {
    'Unincorporated': [
      -118.9446277468019, 32.79959036874079, -117.64637387632716,
      34.82329918755572,
    ],
    'Avalon': [
      -118.34666175222203, 33.318070225968626, -118.30816405883773,
      33.35657167407554,
    ],
    'Norwalk': [
      -118.11156117826701, 33.88029470026223, -118.04220543904741,
      33.93348123659518,
    ],
    'Diamond Bar': [
      -117.86390574951564, 33.960659652791726, -117.76703860726762,
      34.042834237555034,
    ],
    'Pasadena': [
      -118.19823262702413, 34.11726674173058, -118.06562176686886,
      34.251542822055754,
    ],
    'Irwindale': [
      -118.00815463931893, 34.07686533028136, -117.92528770096423,
      34.14122159755455,
    ],
    'La Verne': [
      -117.80143672759081, 34.08620477833573, -117.74769752895017,
      34.16536676226714,
    ],
    'Los Angeles': [
      -118.66815453699239, 33.704583954178666, -118.15535817306001,
      34.337306712300396,
    ],
    'Claremont': [
      -117.7507352111205, 34.07947727040453, -117.6777039550075,
      34.165395311369195,
    ],
    'San Dimas': [
      -117.85392269198232, 34.06365768153469, -117.77225450368307,
      34.16518040160031,
    ],
    'Hawthorne': [
      -118.37870273424053, 33.89335659949296, -118.31340515643565,
      33.93446149517517,
    ],
    'Lynwood': [
      -118.23025568458418, 33.90462535625385, -118.17682420709745,
      33.94547661115971,
    ],
    'South Gate': [
      -118.2313711910909, 33.90991573136241, -118.15624117809251,
      33.966251860120664,
    ],
    'Cudahy': [
      -118.2020276902549, 33.9541034205307, -118.16908835425757,
      33.97095948075889,
    ],
    'Bell Gardens': [
      -118.17028591049527, 33.951893947309834, -118.12936960237576,
      33.97936524148993,
    ],
    'Inglewood': [
      -118.37888907191083, 33.92533394040238, -118.31773070736337,
      33.982884568650036,
    ],
    'Huntington Park': [
      -118.23899861334068, 33.96159425085149, -118.18906521510603,
      33.996216104664676,
    ],
    'Maywood': [
      -118.20455848889826, 33.979994727209615, -118.1699810441637,
      33.99667348383012,
    ],
    'Malibu': [
      -118.92370616868044, 34.00019571124886, -118.58443192810218,
      34.067208260869975,
    ],
    'Signal Hill': [
      -118.18458182203942, 33.78975627215583, -118.14973638087153,
      33.818803602486604,
    ],
    'Lakewood': [
      -118.1677472553748, 33.82005412666689, -118.05898866626522,
      33.8690767559872,
    ],
    'Long Beach': [
      -118.24896620269732, 33.732808600303564, -118.06326735812476,
      33.88554853794073,
    ],
    'Carson': [
      -118.28873810893388, 33.79255202513001, -118.20590747297858,
      33.886187123462406,
    ],
    'Paramount': [
      -118.18814924296798, 33.879798810121585, -118.1428396893986,
      33.918765165419316,
    ],
    'Rolling Hills': [
      -118.36632715759238, 33.74232035451976, -118.3301570927793,
      33.77938618259576,
    ],
    'Rancho Palos Verdes': [
      -118.41923862122373, 33.72191734801871, -118.3010143553389,
      33.79519104598457,
    ],
    'Palos Verdes Estates': [
      -118.42851065780636, 33.762370299137004, -118.35105458226434,
      33.804258261339314,
    ],
    'Redondo Beach': [
      -118.40183446672565, 33.814638032994594, -118.35248770824295,
      33.89462758403722,
    ],
    'Compton': [
      -118.26315310756027, 33.86303295389426, -118.1799450199058,
      33.92314506814954,
    ],
    'Vernon': [
      -118.23975686689185, 33.98313297276836, -118.17008837640452,
      34.01549527632693,
    ],
    'Santa Monica': [
      -118.51774133308359, 33.99509198431491, -118.44351271606497,
      34.05061707984234,
    ],
    'South El Monte': [
      -118.07035337478514, 34.03306615356201, -118.02603168876901,
      34.06453431803624,
    ],
    'West Covina': [
      -117.96708549894988, 34.001739726349314, -117.8578978882776,
      34.09248254788581,
    ],
    'El Monte': [
      -118.072992688169, 34.04164885301321, -117.99733315165345,
      34.10098689279913,
    ],
    'La Puente': [
      -117.98556430136959, 34.00895688597811, -117.92063482262421,
      34.05735152590303,
    ],
    'Pomona': [
      -117.82871981172067, 34.0185549352232, -117.7112221757472,
      34.11260040922027,
    ],
    'Montebello': [
      -118.14407732968273, 33.974477355608876, -118.0730034686126,
      34.04600078846675,
    ],
    'Rosemead': [
      -118.10810294098685, 34.0343623296859, -118.05576879378663,
      34.095017278643006,
    ],
    'Industry': [
      -118.05750486935291, 33.98945077289851, -117.82021288179969,
      34.064098631679606,
    ],
    'Baldwin Park': [
      -118.0076801502015, 34.05514983819731, -117.94304348062842,
      34.10693196090731,
    ],
    'Pico Rivera': [
      -118.12290437547479, 33.950262554657066, -118.04072779615974,
      34.029303238239585,
    ],
    'Walnut': [
      -117.89568826830049, 34.00275666118812, -117.82460661862933,
      34.06248524034484,
    ],
    'Whittier': [
      -118.07229689124766, 33.92803503191508, -117.96513577674745,
      34.030105465817044,
    ],
    'Westlake Village': [
      -118.85641053513422, 34.11032023713674, -118.7888892986324,
      34.168214050446075,
    ],
    'Agoura Hills': [
      -118.80042022740149, 34.125324850482194, -118.71977696683493,
      34.168214050446075,
    ],
    'Santa Clarita': [
      -118.61335232135347, 34.341367308750414, -118.37871352387505,
      34.500030128770725,
    ],
    'Palmdale': [
      -118.2877032508598, 34.510051622054746, -117.916188377158,
      34.66076658665024,
    ],
    'Lancaster': [
      -118.32508272321036, 34.63092354899228, -117.93867266828966,
      34.76914709141609,
    ],
    'Temple City': [
      -118.08146327178513, 34.08537158073112, -118.02843724041698,
      34.1211000429032,
    ],
    'San Marino': [
      -118.14199331943885, 34.10499002441883, -118.08795137189111,
      34.13736327133502,
    ],
    'Bradbury': [
      -117.98592107418035, 34.143616405415614, -117.95127915165605,
      34.165158965284114,
    ],
    'Azusa': [
      -117.94424837055836, 34.10663469969567, -117.88129281800252,
      34.16852256575039,
    ],
    'Sierra Madre': [
      -118.06821465417401, 34.15675410823743, -118.02947333162261,
      34.17940209746067,
    ],
    'Arcadia': [
      -118.06919927870985, 34.087265637138536, -117.99219713600907,
      34.179453760455786,
    ],
    'Glendora': [
      -117.89007427433005, 34.105604537190274, -117.79384241681149,
      34.179662039290555,
    ],
    'Monrovia': [
      -118.02190783420559, 34.10290187629227, -117.94233352409707,
      34.1943146832018,
    ],
    'Duarte': [
      -117.99056376263114, 34.1212845639412, -117.92476395610613,
      34.1942018495489,
    ],
    'South Pasadena': [
      -118.17799486626413, 34.09859502182125, -118.13470077923344,
      34.125572720487284,
    ],
    'Calabasas': [
      -118.71981293595753, 34.103910338286816, -118.60620079030559,
      34.16861152869686,
    ],
    'Burbank': [
      -118.37014809993828, 34.142636156597135, -118.27997826995872,
      34.221654707789575,
    ],
    'La Cañada Flintridge': [
      -118.2318735258874, 34.17787582466735, -118.16742003476573,
      34.24273682075191,
    ],
    'Glendale': [
      -118.30785862949902, 34.11876051004151, -118.18158317072185,
      34.267228871219174,
    ],
    'San Fernando': [
      -118.45602232350707, 34.27338177450998, -118.41579139025903,
      34.30467814294535,
    ],
    'Hidden Hills': [
      -118.6742419294428, 34.15175502440923, -118.63973527924048,
      34.17675221645795,
    ],
    'West Hollywood': [
      -118.39585004353438, 34.076391442758926, -118.34338700059158,
      34.09798026359982,
    ],
    'Alhambra': [
      -118.16529169711184, 34.06003494180355, -118.10807706072497,
      34.11110030357719,
    ],
    'Beverly Hills': [
      -118.4270422981426, 34.05274024526036, -118.37203029668397,
      34.112423008602526,
    ],
    'Bell': [
      -118.2062411527384, 33.96380753848189, -118.1520701333126,
      33.999595984224655,
    ],
    'Manhattan Beach': [
      -118.42330078566997, 33.87281276792257, -118.3786557591148,
      33.90619677031162,
    ],
    'Culver City': [
      -118.44838803073382, 33.976864204420025, -118.36958259644915,
      34.03506985420638,
    ],
    'Covina': [
      -117.92710415414713, 34.068238623466165, -117.84071987132778,
      34.10686808499265,
    ],
    'San Gabriel': [
      -118.12109214556007, 34.0712010466289, -118.0772123345917,
      34.11527756108261,
    ],
    'El Segundo': [
      -118.42994869231626, 33.90165187340038, -118.37444128234233,
      33.93129834296822,
    ],
    'Lawndale': [
      -118.36887857793884, 33.8728322881691, -118.34380923655914,
      33.9024393301783,
    ],
    'Gardena': [
      -118.32651819281612, 33.86553434005419, -118.29061113375265,
      33.916455876685454,
    ],
    'Hermosa Beach': [
      -118.40960401196193, 33.85176892218707, -118.38471917715158,
      33.877801159128566,
    ],
    'Torrance': [
      -118.39436562968957, 33.780519512418074, -118.30835475404768,
      33.887027209289194,
    ],
    'Rolling Hills Estates': [
      -118.393221763173, 33.75715460396952, -118.31517209190507,
      33.795206526382856,
    ],
    'Lomita': [
      -118.32867995902755, 33.774958341148746, -118.30642684672068,
      33.8076557615244,
    ],
    'La Mirada': [
      -118.0379733581113, 33.87331549611271, -117.97656284265133,
      33.928332243641165,
    ],
    'Downey': [
      -118.17039549617715, 33.90234452363198, -118.09032668533317,
      33.972950114072674,
    ],
    'Santa Fe Springs': [
      -118.09843558626342, 33.88262887061213, -118.0288913832745,
      33.974974485990344,
    ],
    'Commerce': [
      -118.19350653928302, 33.97096594913622, -118.12131320930999,
      34.0195412037931,
    ],
    'Monterey Park': [
      -118.16959672668185, 34.02699380060992, -118.09312451020706,
      34.07168485914484,
    ],
    'Artesia': [
      -118.09104550152344, 33.85340801745616, -118.0689279921055,
      33.8803802614081,
    ],
    'Bellflower': [
      -118.15140823186877, 33.865489948344916, -118.10691280140837,
      33.91046453318042,
    ],
    'Cerritos': [
      -118.10862666984877, 33.84587370958547, -118.02871591129995,
      33.88778353068773,
    ],
    'La Habra Heights': [
      -117.99297695767008, 33.94605540938103, -117.91638643580863,
      33.97645748619559,
    ],
    'Hawaiian Gardens': [
      -118.0827100107184, 33.82216726738374, -118.0611989377937,
      33.83864440222842,
    ],
  };

  return bounds[i];
}
